const FORM_ID_PARAM = 'form-id';
const TENANT_ID_PARAM = 'tenant-id';
const FORM_SESSION_TOKEN_PARAM = 'form-session-token';
const ORGANISATION_FORM_SESSION_TOKEN_PARAM = 'form-organisation-session-token';
const PARAM_PREFIX = 'prefill_';
const FORM_ID_PREVIEW_PARAM = 'preview';
const PROJECTID_PARAM = 'projectId';
const FORMID_PARAM = 'formId';
const TENANTID_PARAM = 'tenantId';
const EVENTID_PARAM = 'eventId';
const PROJECT_HASH_PARAM = 'project-token';
const REDIRECT_TO_PARAM = 'redirectTo';

export {
  FORM_ID_PARAM,
  TENANT_ID_PARAM,
  FORM_SESSION_TOKEN_PARAM,
  PARAM_PREFIX,
  FORM_ID_PREVIEW_PARAM,
  ORGANISATION_FORM_SESSION_TOKEN_PARAM,
  PROJECTID_PARAM,
  FORMID_PARAM,
  TENANTID_PARAM,
  EVENTID_PARAM,
  PROJECT_HASH_PARAM,
  REDIRECT_TO_PARAM,
  };
